// /scover/member-portal/src/components/EditProfile.js
import React, { useState, useEffect } from 'react';
import './EditProfile.css';

const EditProfile = ({ auth, goBack }) => {
  const { user, setUser } = auth;
  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    position: '',
    email: '',
    address: '',
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (user && user.token) {
      setLoading(true);
      fetch(`${process.env.REACT_APP_API_URL}/api/members/me`, {
        headers: { 'Authorization': `Bearer ${user.token}` },
      })
        .then((res) => {
          if (!res.ok) throw new Error('Failed to fetch member data');
          return res.json();
        })
        .then((data) => {
          setFormData({
            name: data.name || '',
            surname: data.surname || '',
            position: data.position || '',
            email: data.email || '',
            address: data.address || '',
          });
          setLoading(false);
        })
        .catch((err) => {
          setError(err.message);
          setLoading(false);
        });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/members/me`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${user.token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      if (!response.ok) {
        const text = await response.text();
        throw new Error(`Failed to update profile: ${text}`);
      }
      const updatedUser = await response.json();
      setUser({ ...user, ...updatedUser });
      goBack();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  return (
    <div className="edit-profile">
      <h2>Edit Profile</h2>
      {error && <p className="error">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Name</label>
          <input name="name" value={formData.name} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Surname</label>
          <input name="surname" value={formData.surname} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Position</label>
          <input name="position" value={formData.position} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Email</label>
          <input name="email" value={formData.email} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Address</label>
          <input name="address" value={formData.address} onChange={handleChange} />
        </div>
        <div className="form-buttons">
          <button type="submit" disabled={loading}>Save</button>
          <button type="button" onClick={goBack}>Cancel</button>
        </div>
      </form>
    </div>
  );
};

export default EditProfile;